import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=a3651e74&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3651e74')) {
      api.createRecord('a3651e74', component.options)
    } else {
      api.reload('a3651e74', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=a3651e74&", function () {
      api.rerender('a3651e74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2G1J2YncAYtzc/JS/comp/childrenage.vue"
export default component.exports